const Report = {
  add: () => 'school-report',
  view: () => 'report/list',
  viewByID: () => 'report/form',
  userById: () => `report/create-caseload`,
  reportById: (id: string) => `school-report/${id}`,
}
export default Report
